type AuthToken = {
    accessToken: string
    refreshToken: string
}

type UserInfo = {
    id: number
    username: string
}

type AuthLoginRes = {
    code: number
    msg: string
    data: AuthToken
}

type UserInfoRes = {
    code: number
    msg: string
    data: UserInfo
}

const authLogout = () => {
    const authUser = useState('authUser')
    const accessToken = useState('accessToken')
    const refreshToken = useState('refreshToken')
    const o3AccessToken = useCookie('o3AccessToken')
    const o3RefreshToken = useCookie('o3RefreshToken')

    authUser.value = null
    accessToken.value = null
    refreshToken.value = null
    o3AccessToken.value = null
    o3RefreshToken.value = null

    location.reload()
}


const authPhoneLogin = (phone: string, code: string, wechatAuthCode: string|null = null) => {
    return new Promise((resolve, reject) => {
        // @ts-ignore
        postApi('/user/phoneLogin', {phone, code, wechatAuthCode: wechatAuthCode || ''}).then(async (res: AuthLoginRes) => {
            if(res.code === 0) {
                console.log(res.data.accessToken)
                const accessToken = useState('accessToken')
                const refreshToken = useState('refreshToken')
                const o3AccessToken = useCookie('o3AccessToken')
                const o3RefreshToken = useCookie('o3RefreshToken')
                accessToken.value = res.data.accessToken
                refreshToken.value = res.data.refreshToken
                o3AccessToken.value = res.data.accessToken
                o3RefreshToken.value = res.data.refreshToken
                await updateUserInfo()

                resolve('用户信息')
            } else {

                reject(res.msg)
            }
        }).catch((e) => {
            console.log(e)
            reject('发送请求失败，请检查网络或稍后重试')
        })
    })
}

const authLogin = (username: string, password: string, wechatAuthCode: string|null = null) => {
    return new Promise((resolve, reject) => {
        // @ts-ignore
        postApi('/user/login', {username,password,wechatAuthCode: wechatAuthCode || ''}).then(async (res: AuthLoginRes) => {
            if(res.code === 0) {
                console.log(res.data.accessToken)
                const accessToken = useState('accessToken')
                const refreshToken = useState('refreshToken')
                const o3AccessToken = useCookie('o3AccessToken')
                const o3RefreshToken = useCookie('o3RefreshToken')
                accessToken.value = res.data.accessToken
                refreshToken.value = res.data.refreshToken
                o3AccessToken.value = res.data.accessToken
                o3RefreshToken.value = res.data.refreshToken
                await updateUserInfo()

                resolve('用户信息')
            } else {
                reject(res)
            }
        }).catch((e) => {
            console.log(e)
            reject('发送请求失败，请检查网络或稍后重试')
        })
    })
}

const updateUserInfo = async () => {
    const date = new Date()
    // @ts-ignore
    const res: UserInfoRes = await getApi(`/user/userInfo?_t=${date.getTime()}`)
    const user = res.data
    const authUser = useState('authUser')
    authUser.value = user
}

const updateAccessToken = async () => {
    const accessToken = useState('accessToken')
    const refreshToken = useState('refreshToken')

    const res = await postApi('/user/refreshToken', {
        refreshToken: refreshToken.value as string
    })

    if(res && res.code === 0 && res.data) {
        accessToken.value = res.data.accessToken
        return true
    }

    return false
}

export {authLogin, authPhoneLogin, updateUserInfo, authLogout, updateAccessToken}
